export default __webpack_public_path__ + "static/media/healthCheckMale.f306d5a4.svg";